import { render, staticRenderFns } from "./AnnualForecast.vue?vue&type=template&id=6f80b95c&scoped=true"
import script from "./AnnualForecast.vue?vue&type=script&lang=js"
export * from "./AnnualForecast.vue?vue&type=script&lang=js"
import style0 from "./AnnualForecast.vue?vue&type=style&index=0&id=6f80b95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80b95c",
  null
  
)

export default component.exports